import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './dashboard.component';
import { ProfileComponent } from './../profile/profile.component';
import { AuthGuard } from '@auth0/auth0-angular'; 
import { HistoryComponent } from './../history/history.component';
import { ReviewOrderComponent } from '../review-order/review-order.component';
import { PaymentConfirmComponent } from './../payment-confirm/payment-confirm.component';
import { LoginComponent } from './../login/login.component';
import { TwoFactorVerificationComponent } from '../two-factor-verification/two-factor-verification.component';
import { ErrorMessagesComponent } from '../error-messages/error-messages.component';
import { CallbackComponent } from '../callback/callback.component';
import { UserLoginComponent } from '../user-login/user-login.component';
import { SubscriptionComponent } from '../subscription/subscription.component';
import { ProcessPaymentComponent } from '../process-payment/process-payment.component';
import { SpcComponent } from '../../../SecurePatientCommunication/components/spc/spc.component';
const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'userlog', component: UserLoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'login/:id/:guid/:npi', component: LoginComponent },
  { path: 'callback', component: CallbackComponent },
  { path: 'dashboard', component: DashboardComponent, canActivate:[AuthGuard] },
  { path: 'subscribe', component: SubscriptionComponent },
  { path: 'profile', component: ProfileComponent, canActivate:[AuthGuard] },
  { path: 'PendingPayments', component: HistoryComponent, canActivate:[AuthGuard] },
  { path: 'revieworders', component: ReviewOrderComponent, canActivate:[AuthGuard] },
  { path: 'TransactionDetail',data: {transSetupID: 'value1',primerxPayTransId : 'value2', ApplicationTransId : 'value3', PharmacyNPI:'value3'},component:PaymentConfirmComponent, canActivate:[AuthGuard]},
  { path: 'TwoFactorVerification', component: TwoFactorVerificationComponent, canActivate:[AuthGuard] },
  { path: 'error/:status', component:ErrorMessagesComponent},
  { path: 'payment-confirm', component: PaymentConfirmComponent },
  { path: 'process-payment', component: ProcessPaymentComponent },
  {path : 'spc', component: SpcComponent}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule { }
